<app-search-filter-bar
  [useStatistics]="true"
  (valueChange)="onSearchTermChange($event)"
  (navigateBack)="back()"
  (toggleFilterEvent)="showFilterChartSection() ? showFilterInterface.set(!showFilterInterface()) :
   showFilterChartSection.set(!showFilterChartSection());
showFilterInterface.set(true)"
  (toggleDiagramEvent)="showFilterChartSection() ? showFilterInterface.set(!showFilterInterface()) :
  showFilterChartSection.set(!showFilterChartSection());
showFilterInterface.set(false)"
  #searchBar
></app-search-filter-bar>
<div *ngIf="workplaceService.vm$ | async as view" class="mt-4">
  <ng-container *ngIf="!this.showFilterChartSection(); else filterView">
    <!-- Production Line Layer -->
    <div
      *ngIf="view.showProductionLines && !view.selectedLineId"
      class="d-flex flex-wrap row-gap-2 col-gap-2"
    >
      <div *ngFor="let line of view.productionLines" class="w-50 h-100">
        <app-workplace-card
          class="h-100"
          [workplace]="line"
          [displayProperties]="['activeReports', 'reports']"
          (click)="selectProductionLine(line)"
        ></app-workplace-card>
      </div>
    </div>

    <!-- Workplaces Layer -->
    <div *ngIf="view.selectedLineId">
      <div class="d-flex flex-wrap row-gap-2 col-gap-2">
        <app-workplace-card
          class="w-50 h-100"
          *ngFor="let workplace of view.workplaces"
          [workplace]="workplace"
          [displayProperties]="['activeReports', 'reports']"
          (click)="selectWorkplace(workplace.id!)"
        ></app-workplace-card>
      </div>
    </div>
  </ng-container>

  <ng-template #filterView>
    <div class="d-flex flex-row gap-2 mt-4">
      <section class="report-section">
        <div class="workplace-report-container d-flex justify-content-around">
          <div class="mx-2 w-50">
            <app-workplace-card
              [workplace]="{
            name: sectionHeading,
            reports: solvedReports(),
            activeReports: activeReports()
            }"
              [displayProperties]="['activeReports', 'reports']"
              [totalPages]="totalPages()"
              [pagination]="true"
              (emitPageChange)="this.setPage({page: $event.page, tableType: $event.tableType})"

            />
          </div>
          <div
            class="filter-section w-50"
            *ngIf="showFilterInterface(); else diagramSection"
          >
            <app-filter-interface
                #reportFilter
                (closeFilterInterface)="showFilterChartSection.set(!showFilterChartSection())"
                (filterValueChange)="onFilterValueChange($event)"
            ></app-filter-interface>
          </div>
          <ng-template #diagramSection>
            <div class="card p-4 w-50">
              <div class="close d-flex flex-row-reverse">
                <button class="btn btn-close pt-1"
                        (click)="showFilterChartSection.set(!showFilterChartSection())"></button>
              </div>
              <div class="d-flex flex-column justify-content-start align-items-center">
                <p class="selected-workplace qundis-section-heading-h2">{{ sectionHeading }}</p>
                <p class="diagram-heading">
                  Erfassungszeitraum: {{ getFilterTimeInterval() }}
                </p>
                <div *ngIf="chartData()">
                  <app-pie-chart
                    [chartData]="chartData()!"
                  ></app-pie-chart>
                </div>
              </div>
            </div>

          </ng-template>
        </div>
      </section>
    </div>
  </ng-template>
</div>

<!--<ng-template #filterView>
  <div class="workplace-details d-flex flex-row gap-2 flex-start mt-4">
    <div class="report-section w-50">
      <div class="heading mx-2 d-flex justify-content-between">
        {{
          workplaceService.selectedProductionLineSignal()?.name
            ? workplaceService.selectedProductionLineSignal()?.name
            : "Gesamtübersicht"
        }}
        <i class="bi bi-chevron-right"></i>
      </div>
      <div class="workplace-report-container d-flex">
        <div class="report-section col-7">
          <div class="mx-2 py-2">
            <div>
              <div
                class="active-report-container"
                *ngIf="activeReports(); else noReports"
              >
                <app-report-table
                  [dataSource]="activeReports()!"
                  [tableHeading]="'Aktive Stillstandsmeldungen'"
                  [displayedColumns]="displayedColumns"
                  [tableWidth]="'w-100'"
                ></app-report-table>
              </div>
              <div class="report-container mt-5" *ngIf="solvedReports()">
                <app-report-table
                  [dataSource]="solvedReports()!"
                  [tableHeading]="'Stillstandsmeldungen'"
                  [displayedColumns]="displayedColumns"
                  [tableWidth]="'w-100'"
                ></app-report-table>
              </div>
            </div>
            <ng-template #noReports>
              <p>Keine Stillstandsmeldungen</p>
            </ng-template>
          </div>

          <app-paginator
            [totalPages]="totalPages()"
            (pageChange)="this.setPage($event)"
          ></app-paginator>
        </div>
      </div>
    </div>

  </div>
</ng-template>-->
